import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DataImportBox',
  props: {
    value: { default: '' },
    title: { default: 'Import data' },
    description: { default: 'Copy data from Excel and paste it here' },
    placeholder: { default: 'Paste data from Excel or CSV file...' }
  },
  emits: ["input", "data-pasted"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: string): void;
    (e: 'data-pasted', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, title: string, description: string, placeholder: string };

const { proxy } = getCurrentInstance()!;





const isDragOver = ref(false);

const hasData = computed(() => props.value.trim().length > 0);

const rowCount = computed(() => {
    if (!hasData.value) {
        return 0;
    }
    const lines = props.value.trim().split('\n');
    return Math.max(0, lines.length - 1);
});

function handlePaste(event: ClipboardEvent) {
    event.preventDefault(); // Prevent default paste to avoid double content
    const pastedData = event.clipboardData?.getData('text') || '';
    console.log(pastedData, 'test');
    if (pastedData) {
        emit('input', pastedData);
        emit('data-pasted', pastedData);
    }
}

function handleInput(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    emit('input', target.value);
}

function handleDrop(event: DragEvent) {
    isDragOver.value = false;
    const file = event.dataTransfer?.files[0];
    if (file) {
        readFile(file);
    }
}

function handleFileUpload(file: File) {
    readFile(file);
    return false;
}

function readFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
        const content = e.target?.result as string;
        if (content) {
            emit('input', content);
            emit('data-pasted', content);
        }
    };
    reader.readAsText(file);
}

function clearData() {
    emit('input', '');
}

return { __sfc: true,proxy, props, emit, isDragOver, hasData, rowCount, handlePaste, handleInput, handleDrop, handleFileUpload, readFile, clearData }
}

})